module.exports = __webpack_public_path__ + "static/media/Serenity.05daab6c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Serenity.ttf
// module id = 2295
// module chunks = 50